import styled from "styled-components";

export const DeviceMetricsWrapper = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    grid-gap: 30px;
    grid-template-columns: repeat(1, minmax(0, 1fr));
    grid-auto-rows: minmax(300px, 1fr);

    padding-right: 6px;
    box-sizing: border-box;
`;

export const ChartWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const ChartHeader = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-left: 8px;
`;

export const ChartName = styled.div`
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 2px;
    padding-right: 10px;
    padding-bottom: 5px;
    white-space: nowrap; 
`;

export const ChartHeaderColorBlock = styled.div`
    width: 3px;
    height: 18px;
    margin-bottom: 5px;
`;

export const ChartCurrentValue = styled.div`
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 2px;
    padding-left: 10px;
`;

export const ChartInfo = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right:26px;
`;

export const ChartLatestMetricTime = styled.div`
    margin-left: 8px;
    display: flex;
    font-size: 14px;
    color: #0c0c0c;
    margin-bottom: 8px;
`;

export const ChartUnit = styled.div`
    font-size: 13px;
    color: #555555;
`;

export const EChartsWrapper = styled.div`
    flex: 1 1 auto;
`;

